module.exports = __webpack_public_path__ + "static/media/05.a6be3431.jpg";